import React from 'react';
import { useNavigate } from 'react-router-dom';

function RefundPolicyPage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--light-bg)' }}>
      <div className="header">
        <div className="header-content">
          <h1 className="logo" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>وِداد</h1>
        </div>
      </div>

      <div className="container" style={{ paddingTop: '30px', paddingBottom: '60px', maxWidth: '800px' }}>
        <div className="card fade-in" style={{ padding: '32px', borderRadius: '20px' }}>
          <h1 style={{ fontSize: '28px', color: 'var(--text-dark)', marginBottom: '24px', textAlign: 'center' }}>
            سياسة الاسترداد
          </h1>

          <div style={{ color: 'var(--text-dark)', lineHeight: '2', fontSize: '15px' }}>
            
            {/* English Summary - For Payment Gateway Review */}
            <section style={{ 
              marginBottom: '28px',
              background: 'rgba(0, 137, 123, 0.06)',
              border: '1px solid rgba(0, 137, 123, 0.2)',
              borderRadius: '12px',
              padding: '20px',
              direction: 'ltr',
              textAlign: 'left'
            }}>
              <h2 style={{ fontSize: '17px', color: 'var(--primary)', marginBottom: '10px' }}>
                Refund Policy Summary (English)
              </h2>
              <p style={{ fontSize: '14px', lineHeight: '1.8' }}>
                Subscribers may request a <strong>full refund within 30 days</strong> of purchase if the service
                was not used or if technical issues prevented usage. Refunds are processed via the original
                payment method within <strong>5–10 business days</strong>. To request a refund, contact{' '}
                <strong>help@wedad.online</strong> with your account email and reason. Refunds are <strong>not</strong>{' '}
                granted after 30 days, for accounts banned due to policy violations, or for memberships fully
                consumed (e.g., contact information already exchanged with multiple matches).
              </p>
              <p style={{ fontSize: '14px', lineHeight: '1.8', marginTop: '10px' }}>
                <strong>Cancellation:</strong> You may cancel auto-renewal at any time from your account
                settings. Cancellation takes effect at the end of the current billing period; no proration
                or partial refunds are issued for unused days within the current cycle.
              </p>
            </section>

            <section style={{ marginBottom: '28px' }}>
              <h2 style={{ fontSize: '18px', color: 'var(--primary)', marginBottom: '12px' }}>1. نطاق السياسة</h2>
              <p>تنطبق سياسة الاسترداد هذه على جميع المشتركين في خدمات وِداد المميزة. نحرص على رضاكم التام عن خدماتنا.</p>
            </section>

            <section style={{ marginBottom: '28px' }}>
              <h2 style={{ fontSize: '18px', color: 'var(--primary)', marginBottom: '12px' }}>2. ضمان الاسترداد</h2>
              <ul style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '8px' }}>يحق للمشترك طلب استرداد كامل المبلغ خلال <strong>30 يوم</strong> من تاريخ الاشتراك.</li>
                <li style={{ marginBottom: '8px' }}>يجب أن يكون الطلب مبرراً (مثل: عدم الرضا عن الخدمة، مشاكل تقنية).</li>
                <li style={{ marginBottom: '8px' }}>يتم الاسترداد بنفس طريقة الدفع الأصلية خلال <strong>5-10 أيام عمل</strong>.</li>
              </ul>
            </section>

            <section style={{ marginBottom: '28px' }}>
              <h2 style={{ fontSize: '18px', color: 'var(--primary)', marginBottom: '12px' }}>3. حالات الاسترداد</h2>
              <div style={{ 
                background: 'rgba(0, 217, 165, 0.08)', 
                border: '1px solid rgba(0, 217, 165, 0.2)',
                borderRadius: '12px', padding: '16px', marginBottom: '12px'
              }}>
                <h3 style={{ color: 'var(--success)', fontSize: '15px', marginBottom: '8px' }}>يتم الاسترداد في الحالات التالية:</h3>
                <ul style={{ paddingRight: '20px', margin: 0 }}>
                  <li>طلب الاسترداد خلال 30 يوم من الاشتراك</li>
                  <li>وجود خلل تقني يمنع استخدام الخدمة</li>
                  <li>خصم مبلغ غير صحيح أو مكرر</li>
                </ul>
              </div>
              <div style={{ 
                background: 'rgba(255, 87, 87, 0.08)',
                border: '1px solid rgba(255, 87, 87, 0.2)',
                borderRadius: '12px', padding: '16px'
              }}>
                <h3 style={{ color: 'var(--error)', fontSize: '15px', marginBottom: '8px' }}>لا يتم الاسترداد في الحالات التالية:</h3>
                <ul style={{ paddingRight: '20px', margin: 0 }}>
                  <li>مرور أكثر من 30 يوم على الاشتراك</li>
                  <li>مخالفة شروط الاستخدام أو إساءة استخدام المنصة</li>
                  <li>حظر الحساب بسبب انتهاك السياسات</li>
                </ul>
              </div>
            </section>

            <section style={{ marginBottom: '28px' }}>
              <h2 style={{ fontSize: '18px', color: 'var(--primary)', marginBottom: '12px' }}>4. كيفية طلب الاسترداد</h2>
              <ol style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '8px' }}>تواصل معنا عبر صفحة "اتصل بنا" أو البريد الإلكتروني</li>
                <li style={{ marginBottom: '8px' }}>اذكر سبب طلب الاسترداد وبيانات حسابك</li>
                <li style={{ marginBottom: '8px' }}>سنراجع طلبك ونرد عليك خلال 48 ساعة</li>
                <li style={{ marginBottom: '8px' }}>عند الموافقة، يتم التحويل خلال 5-10 أيام عمل</li>
              </ol>
            </section>

            <section style={{ marginBottom: '28px' }}>
              <h2 style={{ fontSize: '18px', color: 'var(--primary)', marginBottom: '12px' }}>5. إلغاء الاشتراك</h2>
              <p>يمكنك إلغاء اشتراكك في أي وقت. عند الإلغاء:</p>
              <ul style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '8px' }}>تستمر في الاستفادة من الخدمة حتى نهاية فترة الاشتراك الحالية.</li>
                <li style={{ marginBottom: '8px' }}>لن يتم تجديد الاشتراك تلقائياً.</li>
                <li style={{ marginBottom: '8px' }}>يبقى حسابك نشطاً بالعضوية المجانية.</li>
              </ul>
            </section>

            <section style={{ 
              background: 'rgba(79, 172, 254, 0.08)',
              border: '1px solid rgba(79, 172, 254, 0.2)',
              borderRadius: '12px', padding: '20px', textAlign: 'center'
            }}>
              <p style={{ margin: 0, fontSize: '14px', color: 'var(--text-light)' }}>
                للتواصل معنا: <strong>help@wedad.online</strong>
              </p>
              <p style={{ margin: '8px 0 0', fontSize: '13px', color: 'var(--text-light)' }}>
                آخر تحديث: أبريل 2026
              </p>
            </section>
          </div>

          <button 
            className="btn btn-primary"
            onClick={() => navigate(-1)}
            style={{ marginTop: '24px', width: '100%' }}
          >
            رجوع
          </button>
        </div>
      </div>
    </div>
  );
}

export default RefundPolicyPage;
